export default {
     axiosBaseUrl:'http://hz.richcyber.com:8085', //api请求文件
     fontUrl:'http://hz.richcyber.com:8085', //图片处理路径
     showVideo:'https://wx.vzan.com/live/tvchat-1279988425?shauid=QFqKmYPsyso6CjvkQcjHnw**&vprid=0&sharetstamp=1634692363609&ver=d2d2b512437e4fd48a59e9056c008182',   //视频直播
     showPicture:'https://live.photoplus.cn/live/9257501?uniqCode=iBs9H9ybQj&accessFrom=live',  //图片直播,
     viewcz: "http://hz.richcyber.com:8081/hz/f/list.html?categoryId=8ff76b57a6674525a898d5ba4026352c",   //我要参展
     viewcg: "http://hz.richcyber.com:8081/hz/f/list.html?categoryId=423d542b5b2343f1ac216b425aa7ae33", // 参展申请
     zwt:'http://hz.richcyber.com:8081/hz/f/hz/gzZwtIndex.html?categoryId=6f595480c4c74329bae5448ddf19cb8a', //展位图
     zhrc:'http://hz.richcyber.com:8081/hz/f/list.html?categoryId=70b5d6c9d45245a09e51eff9b334e3c6',  //展会日程
     hzzhanhui:'http://hz.richcyber.com:8081/hz/f',  //展会官网,
};



